import apiClient from "./axios-client";

/**
 * get-edc-transaction-details
 * @returns
 */
export const getEdcTransactionDetails = async (body) => {
  const response = await apiClient.post(
    `receipt/get-edc-transaction-details`,
    body
  );
  return response.data;
};

/**
 * get-edc-status-and-generate-receipt
 * @returns
 */
export const getEdcTransactionDetailsAndGenerateReceipt = async (body) => {
  const response = await apiClient.post(
    `receipt/get-edc-status-and-generate-receipt`,
    body
  );
  return response.data;
};
